import React from 'react';
import styled from 'styled-components';
import { Colors } from '@inplayer-org/inplayer-ui';

import logo from 'assets/pics/icons/inplayer-logo-dark-blue.svg';

const EmailWrapper = styled.div`
  width: 70%;
  margin: 0 auto;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border: 1px solid ${Colors.gray};
  border-top: 6px solid ${Colors.blue};
`;

const StyledImg = styled.img`
  width: 40% !important;
`;

const LogoWrapper = styled.div`
  width: 100%;
  border-bottom: 1px solid ${Colors.gray};
  display: flex;
  justify-content: center;
  padding: 1.5rem;
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 3rem 4rem;
`;

const EmailHeader = styled.h2`
  align-self: center;
  margin-bottom: 2rem;
`;

const StyledLink = styled.a`
  text-decoration: underline;
`;

const DescriptionWrapper = styled.div`
  margin: 0.75rem 0;
  display: flex;
  flex-direction: column;
`;

const StyledSpan = styled.span<{ isBold?: boolean }>`
  ${({ isBold, theme }) => isBold && `font-weight: ${theme.font.weights.bold};`}
  margin-top: 0.5rem;
`;

const GiftEmailExample: React.FC = () => (
  <EmailWrapper>
    <LogoWrapper>
      <StyledImg src={logo} alt="inplayer-logo" title="InPlayer" />
    </LogoWrapper>
    <ContentWrapper>
      <EmailHeader>{`You got a gift from {{.email}}!`}</EmailHeader>
      <EmailHeader as="p">The gift is a 100% discount voucher.</EmailHeader>
      <DescriptionWrapper>
        <span>Voucher code:</span>
        <StyledSpan isBold>{`{{.voucher}}`}</StyledSpan>
      </DescriptionWrapper>
      <DescriptionWrapper>
        <span>The voucher can be used to purchase the price option:</span>
        <StyledSpan isBold>{`{{price option variable}}`}</StyledSpan>
      </DescriptionWrapper>
      <DescriptionWrapper>
        <span>Gift description:</span>
        <StyledSpan>{`{{.voucher_description}}`}</StyledSpan>
      </DescriptionWrapper>
      <DescriptionWrapper>
        <StyledLink href="https://support.inplayer.com/#how-do-i-redeem-my-gift" target="_blank">
          How do I redeem my gift?
        </StyledLink>
      </DescriptionWrapper>
    </ContentWrapper>
  </EmailWrapper>
);

export default GiftEmailExample;
